import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 官网订单接单列表-分页（沃行 Sales → 接单列表）
export function pageWebOrder(data) {
  return request({ url: URL.webOrder.page, method: 'post', data })
}

// 官网订单详情
export function getWebOrder(uuid) {
  return request({ url: URL.webOrder.getBase + uuid, method: 'get' })
}

// 接单（返回映射的海运出口工作单 SeaExportJobDetailVO，供 RemoteBooking webAccept 落单）
export function acceptWebOrder(id) {
  return request({ url: URL.webOrder.accept, method: 'post', params: { id }})
}

// 接单回调：RemoteBooking 保存创建 OMS_JOB 成功后回写官网订单（状态=已接单 + jobNo/jobId）
export function acceptCallbackWebOrder(data) {
  return request({ url: URL.webOrder.acceptCallback, method: 'post', data })
}

// 拒绝
export function rejectWebOrder(id, rejectReason) {
  return request({ url: URL.webOrder.reject, method: 'post', params: { id, rejectReason }})
}
